import { Routes } from '@angular/router';

export const invoiceRoutes: Routes = [
  { path: '', redirectTo: 'invoices', pathMatch: 'full' },
  {
    path: 'invoices',
    loadComponent: () =>
      import('./invoices-page/invoices-page').then((m) => m.InvoicesPage),
    children: [
      {
        path: '',
        loadComponent: () => import('./invoice/invoice').then((m) => m.Invoice),
      },
      {
        path: 'invoice-list/:id',
        loadComponent: () =>
          import('./invoice-list/invoice-list').then((m) => m.InvoiceList),
      },
      {
        path: 'invoice-detail/:id',
        loadComponent: () =>
          import('./invoice-detail-page/invoice-detail-page').then((m) => m.InvoiceDetailPage),
      }
    ],
  },
];
